import { writable } from 'svelte/store'

export const activeSlideIndex = writable(0)
export const tooTallSlides = writable(false)
